import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Loader from './Loader';

const ProtectedRoute = ({ children }) => {
    const { user, userMetaData, loading } = useAuth();

    if (loading) {
        return <Loader />;
    }

    if (!user) {
        return <Navigate to="/sign-in" />;
    }else{
        if(!userMetaData){
            return <Navigate to="/sign-in" />;
            
        }else{
            if(userMetaData.user_role !== "subscriber"){
                return <Navigate to="/sign-in" />;
            }
        }
    }

    return children;
};

export default ProtectedRoute;